import { useTranslation } from "react-i18next";

import { timestampColumn } from "../../../../ui/utils/columns";

export default function useContractorsTableColumns() {
	const { t } = useTranslation();

	return [
		{
			id: "name",
			Header: t("name", "Name"),
		},
		timestampColumn({ id: "created", Header: t("created", "Created"), collapsing: false }),
	];
}
